export default {
  // Header
  header: {
    activities: '最新活動',
    products: '產品',
    solutions: '解決方案',
    partners: '合作夥伴',
    aboutUs: '關於我們',
    login: '登入',
    register: '免費註冊',
    search: '搜尋產品、文件...',
    registerBenefits: '註冊即可獲得福利：',
    benefit1: '30+產品免費試用',
    benefit2: '新用戶專屬優惠',
    benefit3: '優先體驗新產品',
    signUpFree: '免費註冊'
  },
  
  // Search
  search: {
    quickAccess: '快速訪問',
    hotProducts: '熱門產品',
    hkServer: '香港伺服器',
    cloudServer: '雲伺服器',
    ddosProtection: 'DDoS防護',
    sslCertificate: 'SSL證書',
    bgpServer: 'BGP伺服器',
    colocation: '伺服器託管',
    multiIpServer: '站群伺服器'
  },
  
  // Footer
  footer: {
    support247: '24/7',
    premiumSupport: '專業支援',
    newUser: '新用戶',
    freeTrials: '免費試用',
    alwaysOn: '全天候',
    expertGuidance: '專家指導',
    reliable: '可靠',
    uptime: '99.95% 在線率',
    
    companyIntro: '公司介紹',
    aboutUs: '關於我們',
    joinUs: '加入我們',
    industryNews: '行業資訊',
    
    support: '支援',
    contactSales: '聯繫銷售',
    openTicket: '開通工單',
    tickets: '工單',
    searchDownloads: '下載中心',
    knowledgebase: '知識庫',
    announcements: '公告',
    networkStatus: '網路狀態',
    
    billing: '帳單',
    invoices: '發票',
    quotes: '報價',
    paymentMethod: '付款方式',
    addFunds: '充值',
    viewCart: '購物車',
    
    accountOverview: '帳戶概覽',
    manageAccount: '管理帳戶',
    userManagement: '用戶管理',
    accountSecurity: '帳戶安全',
    
    hotline: '24小時熱線',
    companyName: 'Nebula Global LLC',
    companyAddress: '1359 S DREXEL WAY LAKEWOOD CO 80232 US',
    // companyEmail 已移至 /config.js
    companyPhone: '+1(970)516-9999',
    companyDesc: 'SCGIDC: 優質雲解決方案。願景：打造可信賴、高性價比的雲品牌。',
    
    copyright: 'Copyright © 2024-2026 Nebula Global LLC. 保留所有權利。',
    termsOfService: '服務條款',
    privacyPolicy: '隱私政策',
    acceptableUsePolicy: '使用規範',
    dsaPolicy: 'DSA政策',
    dmcaPolicy: 'DMCA政策'
  },
  
  // Home
  home: {
    // Banner 1
    banner1Tag1: '超低延遲',
    banner1Tag2: '中港直連',
    banner1Title: '香港伺服器：優惠特惠',
    banner1MainDesc: '強勁性能，極致網絡',
    banner1SubDesc: '站群 \u00b7 優質 IP | 高帶寬 \u00b7 新上線',
    // Banner 2
    banner2Tag1: '成熟架構',
    banner2Tag2: 'CN2直連',
    banner2Title: '日本雲伺服器：擴容升級',
    banner2MainDesc: '資源池擴容 \u00b7 全新體驗',
    // Banner 3
    banner3Tag1: '高防護',
    banner3Tag2: '支持壓測',
    banner3Title: '香港高防IP升級',
    banner3MainDesc: '高防護 \u00b7 快速接入',
    banner3SubDesc: '200G真實防禦，3分鐘接入，彈性防護',
    // Slide tabs
    bannerTitle1: '香港伺服器',
    bannerDesc1: '超低延遲，優惠價格',
    bannerTitle2: '日本雲',
    bannerDesc2: '資源池擴容',
    bannerTitle3: '高防IP',
    bannerDesc3: '200G真實防禦，快速開通',
    
    globalPartners: '全球頂級網路合作夥伴',
    hotProducts: '高速免備案產品',
    hotProductsDesc: '14年經驗，10萬+客戶',
    featured: '精選',
    cloudServers: '雲伺服器',
    physicalServers: '實體伺服器',
    antiDdos: '高防服務',
    
    buyNow: '立即購買',
    details: '查看詳情',
    viewDetails: '查看詳情',
    consultNow: '立即諮詢',
    productDetails: '產品詳情',
    console: '控制台',
    contactUs: '聯繫我們',
    contactSales: '聯繫銷售',
    
    expert1v1: '1對1專家',
    customSolutions: '定制解決方案',
    freeMigration: '免費遷移指南',
    insiderDeals: '內部優惠',
    expertSupport: '專家支援',
    customProtection: '定制防護',
    alwaysAvailable: '全天候服務',
    budgetFriendly: '性價比高',
    enterpriseGrade: '企業級',
    instantSetup: '即時開通',
    
    // Product cards
    cloudServer: '雲伺服器',
    physicalServer: '實體伺服器',
    antiDdosServer: '高防伺服器',
    antiDdosIp: '高防IP',
    antiDdosCloud: '高防雲',
    hkCloudServer: '香港雲伺服器',
    jpCloudServer: '日本雲伺服器',
    usCloudServer: '美國雲伺服器',
    hkAntiDdosCloud: '香港高防雲',
    hkCloudIntl: '香港雲(國際)',
    hkCloudOptimized: '香港雲(優化)',
    hkServer: '香港伺服器',
    jpServer: '日本伺服器',
    hkHighBwServer: '香港高帶寬伺服器',
    hkMultiIpServer: '香港多IP伺服器',
    usServer: '美國伺服器',
    krServer: '韓國伺服器',
    hkAntiDdosServer: '香港高防伺服器',
    hkAntiDdosIp: '香港高防IP',
    usAntiDdos: '美國高防',
    
    // Product descriptions
    ddosProtection300G: '300G DDoS防護',
    ddosDefense200G: '200G防禦3分鐘接入',
    smartMitigation: '智能清洗',
    noIcpBestseller: '免備案爆款',
    multiLineOptions: '多線路可選',
    latencyToChina: '國內延遲60-120ms',
    cn2Gia: 'CN2 GIA',
    dedicatedBw: '延遲120-180ms，獨享帶寬',
    payByTraffic: '按流量計費',
    ddosProtected: '300G DDoS防護',
    globalBandwidth: '全球帶寬',
    bw30MPlus: '30M+帶寬',
    costEffective: '性價比高',
    bw10MPlus: '10M+帶寬',
    clients100K: '10萬+客戶',
    freeIntranet: '免費內網',
    fastChinaAccess: '國內訪問快',
    standard20M: '20M標準',
    optimizedBw300M: '300M優化帶寬',
    rapidDeployment: '快速部署',
    bulkIpsAvailable: '可批量IP',
    cn2Optional30M: '30M CN2可選',
    freeDefense10G: '免費10G防禦',
    premiumKtLgDc: '優質KT/LG機房',
    protection310G: '310G防護',
    testBeforeBuy: '先測試後購買',
    upgraded: '已升級',
    elasticDefense300G: '300G彈性防禦',
    scaleOnDemand: '按需擴展',
    tier1Protection: '一級防護',
    protectedIps5: '5個防護IP',
    
    ddosExpertise14yr: '14年防禦經驗',
    shopNow: '立即購買',
    
    solutionsTitle: '經驗豐富的場景解決方案',
    solutionsDesc: '為不同業務場景提供專業解決方案，提供多樣化選擇',
    retail: '零售',
    retailDesc: '全渠道行銷、會員管理、客戶終身價值。推動零售數字化。',
    automotive: '汽車',
    automotiveDesc: '個性化出行、深入用戶互動。加速原廠數字化轉型。',
    finance: '金融',
    financeDesc: '資產管理增長、智能風控、智慧網點。提升金融智能化。',
    cultureTourism: '文旅',
    cultureTourismDesc: '在線運營促增長，行業數字化。為政府、企業和遊客提供指南。',
    internetPlus: '互聯網+',
    internetPlusDesc: '一站式基礎設施、數據、媒體和AI。助力業務增長。',
    contactSupport: '聯繫支援',
    
    announcements: '最新公告',
    announcementsDesc: '了解我們的最新動態',
    viewAll: '查看全部',
    
    perMonth: '/月',
    perYear: '/年',
    startingFrom: '起',
    
    // Features section
    featuresTitle: '14年港澳/海外伺服器專家',
    featuresDesc: '14年全球伺服器管理經驗',
    
    feature1Title: '14年IDC老兵',
    feature1Desc: '企業ICT解決方案：全球託管、網絡、容災',
    feature1Link: '關於我們',
    
    feature2Title: '資源多樣性',
    feature2Desc: 'APNIC/ARIN成員，擁有ASN，豐富IPv4/IPv6資源',
    feature2Link: '聯繫支援',
    
    feature3Title: '全球低延遲',
    feature3Desc: '港/美/日/韓直連CN2/CMI/聯通，BGP冗餘',
    feature3Link: '測試IP',
    
    feature4Title: 'Tier\u2162+數據中心',
    feature4Desc: '2N冗餘，99.982%運行時間',
    feature4Link: '數據中心',
    
    feature5Title: '無需備案',
    feature5Desc: '即時部署：從雲伺服器到裸金屬',
    feature5Link: '聯繫支援',
    
    feature6Title: '24/7現場支援',
    feature6Desc: 'CCIE團隊駐場，快速響應故障',
    feature6Link: '提交工單',
    
    feature7Title: '年度硬體更新',
    feature7Desc: '防止硬體老化問題',
    feature7Link: '硬體定制',
    
    feature8Title: '數據隱私',
    feature8Desc: '客戶數據完全自主',
    feature8Link: '隱私政策',
    
    feature9Title: '99.9%運行時間SLA',
    feature9Desc: '保證賠償',
    feature9Link: 'SLA詳情',
    
    feature10Title: '24/7優質支援',
    feature10Desc: '多渠道隨時響應',
    feature10Link: '定制服務',
    
    // Solutions section
    retail: '零售',
    retailDesc: '全渠道營銷、會員管理、客戶終身價值。推動零售數字化。',
    automotive: '汽車',
    automotiveDesc: '個性化出行，更深用戶參與。加速OEM數字化轉型。',
    finance: '金融',
    financeDesc: 'AUM增長、智能風控、智慧網點。提升金融智能化。',
    cultureTourism: '文旅',
    cultureTourismDesc: '在線運營促增長，行業數字化。成為政府、企業、遊客的向導。',
    internetPlus: '互聯網+',
    internetPlusDesc: '一站式基礎設施、數據、媒體與AI。助力業務增長。',
    contactSupport: '聯繫支援',
    
    // Region labels
    hkUsJp: '港/美/日',
    hkUs: '港/美',
    hongKong: '香港',
    
    // Tags
    tagHot: '熱門',
    tagNew: '新品'
  },
  
  // Announcements
  announcements: {
    item1Title: '香港伺服器擴容完成',
    item1Desc: '新的高性能節點現已上線，帶寬容量增強',
    item2Title: '新年促銷：七折優惠',
    item2Desc: '所有雲伺服器和專用主機計劃限時優惠',
    item3Title: 'DDoS防護升級至300G',
    item3Desc: '增強的防護能力，更快的響應時間',
    item4Title: '日本數據中心上線',
    item4Desc: '亞太地區超低延遲連接',
    tagUpdate: '更新',
    tagPromo: '促銷',
    tagNew: '新品',
    tagLaunch: '上線'
  },
  
  // Products Menu
  products: {
    allProducts: '全部產品',
    physicalServer: '實體伺服器',
    cabinetRental: '機櫃租賃',
    cloudServer: '雲伺服器',
    ddosProtection: 'DDoS防護',
    crossBuildingLinks: '樓內互聯',
    multiIpServers: '站群伺服器',
    sslCertificates: 'SSL證書',
    domains: '域名'
  },
  
  // Solutions Menu
  solutions: {
    service: '服務',
    serviceDesc: '專業服務解決方案',
    colocation: '伺服器託管',
    colocationDesc: '專業伺服器託管服務',
    bandwidth: '帶寬',
    bandwidthDesc: '高速帶寬解決方案',
    ipTransit: 'IP Transit',
    ipTransitDesc: '企業級IP傳輸解決方案，全球覆蓋',
    crossCloud: '跨雲連接',
    crossCloudDesc: '安全的多雲網路連接',
    hybridCloud: '混合雲',
    hybridCloudDesc: '公有雲和私有雲的無縫集成',
    dcInterconnect: '數據中心互聯',
    dcInterconnectDesc: '高性能數據中心互聯'
  },
  
  // Partners Menu
  partners: {
    partners: '合作夥伴',
    partnerWithUs: '與我們合作',
    joinProgram: '加入我們的合作夥伴計劃',
    affiliateProgram: '推廣聯盟',
    affiliateDesc: '賺取15%傭金！$50獎勵'
  },
  
  // About Menu (Header dropdown)
  aboutMenu: {
    infrastructure: '基礎設施',
    expertise: '10+年香港/海外經驗',
    companyIntro: '公司介紹',
    history: '發展歷程',
    joinUs: '加入我們',
    contactUs: '聯繫我們'
  },
  
  // Server Products
  serverProducts: {
    hkBgpPremium: '香港BGP精品系列',
    hkBgpStandard: '香港BGP優品系列',
    hkBgpGlobal: '香港BGP國際',
    hkBgpAntiDdos: '香港BGP高防系列',
    hkBgpPremiumDesc: '直連全球最多的ISP路由，包含中國大陸地區',
    cloud: '雲伺服器',
    antiDdos: 'DDoS防護',
    hkColocation: '香港伺服器託管',
    crossBuilding: '樓內線互聯',
    siteCluster: '站群伺服器',
    ssl: 'SSL證書'
  },
  
  // Common
  common: {
    learnMore: '了解更多',
    contactUs: '聯繫我們',
    month: '/月',
    year: '/年',
    hot: '熱門',
    new: '新品',
    viewDetails: '查看詳情',
    shopNow: '立即購買'
  },

  // About Page
  about: {
    aboutUs: '關於我們',
    companyName: 'Nebula Global LLC',
    companySlogan: '全球數據中心提供商，APNIC/ARIN成員，擁有ASN、IPv4/IPv6資源',
    clientArea: '用戶中心',
    companyIntro: '公司介紹',
    joinUs: '加入我們',
    companyDesc: 'SCGIDC: 為開發者、政府、金融機構提供企業級雲解決方案。',
    visionMission: '願景與使命',
    vision: '願景',
    visionText: '構建更美好的數字社會',
    mission: '使命',
    missionText: '讓世界更高效',
    globalOffices: '全球辦事處',
    singapore: '新加坡',
    hongKong: '香港',
    losAngeles: '洛杉磯',
    korea: '韓國',
    whyChooseUs: '為什麼選擇我們',
    feature1Title: '安全與可靠',
    feature1Desc: '多層安全防護和99.95% SLA保障',
    feature2Title: '全球網絡',
    feature2Desc: '優質的全球主要區域網絡連接',
    feature3Title: '24/7支援',
    feature3Desc: '全天候專家技術支援',
    followUs: '關注我們',
    socialDesc: '在社交媒體上關注我們，獲取最新動態和資訊'
  },

  // Data Center Page
  datacenter: {
    title: '數據中心',
    globalDataCenters: '全球數據中心',
    subtitle: '企業級基礎設施，提供99.99%正常運行時間SLA',
    explore: '探索數據中心',
    learnMore: '了解更多',
    features: '特性',
    specs: '規格',
    certifications: '認證',
    location: '位置',
    tier: '等級評級',
    power: '電力基礎設施',
    cooling: '製冷系統',
    connectivity: '連接性',
    security: '安全',
    back: '返回列表',
    select: '選擇數據中心',
    overview: '概覽',
    network: '網絡',
    securityCompliance: '安全與合規',
    allDataCenters: '所有數據中心',
    backToList: '返回列表',
    viewProducts: '查看產品',
    specifications: '規格參數',
    infrastructure: '基礎設施',
    ourLocations: '我們的位置',
    locationsDesc: '點擊位置了解更多數據中心設施資訊',
    clientArea: '客戶中心',
    centers: {
      'mega-i': {
        name: 'MEGA-i 香港數據中心',
        region: '香港',
        location: '香港柴灣',
        subtitle: '亞洲頂級互聯樞紐 · 營運商密度最高的設施',
        advantageTitle: 'MEGA-i 競爭優勢',
        infrastructureTitle: '軍工級基礎設施',
        notices: [
          { title: 'Tier III+ 認證設施', desc: '99.982%可用性，雙路電源+24小時備電' },
          { title: '亞洲網絡樞紐', desc: '直連9條海底光纜和300+營運商' },
          { title: '營運商中立環境', desc: '靈活選擇營運商，支援AWS/Azure雲連接' }
        ],
        descriptions: [
          '位於柴灣道399號的35萬平方英尺旗艦設施 - 亞洲網絡互聯核心',
          '連接香港9/11條海底光纜：到東京<45ms，到新加坡<15ms，到洛杉磯<110ms',
          'HKCA“創新數據中心服務”獲獎者，LEED金級認證(PUE≤1.5)'
        ],
        infrastructure: [
          { title: '電力系統', items: ['雙路11kV電源(2000kVA變壓器)', 'N+1冗餘UPS(400kVA/層)+30分鐘電池', '2000kVA柴油發電機(24/7連續供電)'] },
          { title: '製冷系統', items: ['精密製冷: 20℃±2℃, 50%±10%濕度', '冷水機組+直接膨脹雙系統', '熱通道封閉技術, PUE≤1.5'] },
          { title: '消防系統', items: ['VESDA吸氣式煙霧探測', 'FM200潔淨氣體滅火系統'] },
          { title: '網絡架構', items: ['15,000+交叉連接高速互聯', '100mm鋼管保護光纖主幹'] },
          { title: '安全系統', items: ['雙門互鎖+生物識別門禁', '紅外熱成像監控+武裝巡邏'] },
          { title: '運維支援', items: ['24/7現場工程支援', '15分鐘故障響應SLA保證'] }
        ]
      },
      'chief': {
        name: '是方電訊立元數據中心',
        region: '香港',
        location: '香港葵涌',
        subtitle: '亞洲光纜樞紐 · 90%跨太平洋流量節點',
        advantageTitle: '東亞數字樞紐',
        infrastructureTitle: '軍工級基礎設施',
        notices: [
          { title: 'Tier III+ 認證設施', desc: '99.982%正常運行，雙路11kV供電+72小時備電' },
          { title: '亞洲海底光纜樞紐', desc: '直連9條承載90%亞洲跨太平洋流量的光纜' },
          { title: '營運商中立環境', desc: '200+營運商，多路徑BGP路由' }
        ],
        descriptions: [
          '位於台北陽光街6層專用IDC設施(10,000+平方米)',
          '連接TPIX/TPVX/TPCX交換中心: 到東京<15ms, 到新加坡<35ms',
          '中華電信子公司(ISO 27001/9001)，支援AWS/Azure直連'
        ],
        infrastructure: [
          { title: '電力系統', items: ['2N冗餘UPS(總計18,000KVA)', '雙路11kV供電+柴油備電(72小時)'] },
          { title: '製冷系統', items: ['N+1冗餘冷水機(22±2℃)', '熱通道封閉(PUE≤1.5)'] },
          { title: '消防系統', items: ['VESDA + FM200滅火系統'] },
          { title: '網絡架構', items: ['BGP智能路由(CT/CU/CM/EDU)', '15,000+交叉連接，100Gbps互聯'] },
          { title: '物理安全', items: ['生物識別+熱成像+防尾隨'] },
          { title: '運維支援', items: ['24/7現場工程師，15分鐘響應SLA'] }
        ]
      },
      'globalswitch': {
        name: 'Global Switch 香港',
        region: '香港',
        location: '香港將軍澳',
        subtitle: '世界級營運商中立設施 · 綠色能源認證',
        advantageTitle: 'Global Switch 優勢',
        infrastructureTitle: '軍工級基礎設施',
        notices: [
          { title: '世界級基礎設施', desc: '專建設施，2N+1冗餘' },
          { title: '綠色能源認證', desc: 'LEED認證，行業領先PUE' },
          { title: '100+營運商連接', desc: '廣泛的網絡提供商生態' }
        ],
        descriptions: [
          '位於將軍澳工業邨的高端數據中心園區',
          '多層安全防護，24/7現場人員',
          '直連主要雲提供商和營運商'
        ],
        infrastructure: [
          { title: '電力系統', items: ['2N+1冗餘電力架構', '多路市電+柴油備用'] },
          { title: '製冷系統', items: ['冷熱通道封閉', '高效節能製冷系統'] },
          { title: '消防系統', items: ['VESDA早期預警探測', '氣體滅火系統'] },
          { title: '網絡', items: ['100+營運商選擇', '雲直連接入'] },
          { title: '安全', items: ['多層物理安全', '生物識別門禁'] },
          { title: '運維', items: ['24/7 NOC支援', '遠程手服務'] }
        ]
      },
      'eq-sg1': {
        name: 'Equinix SG1 新加坡',
        region: '新加坡',
        location: '新加坡',
        subtitle: '東南亞門戶 · 高端 IBX 數據中心',
        advantageTitle: 'Equinix 新加坡優勢',
        infrastructureTitle: '企業級基礎設施',
        notices: [
          { title: 'IBX 高端設施', desc: '行業領先的互聯平台' },
          { title: '雲直連', desc: 'AWS、Azure、Google Cloud直連' },
          { title: '豐富生態', desc: '500+網絡和2,000+企業' }
        ],
        descriptions: [
          '位於東南亞金融中心的戰略位置',
          'Equinix Fabric軟體定義互聯',
          '全面的合規認證'
        ],
        infrastructure: [
          { title: '電力系統', items: ['2N UPS + 柴油發電機', 'SLA保障的正常運行時間'] },
          { title: '製冷系統', items: ['冷水製冷', 'N+1冗餘'] },
          { title: '消防系統', items: ['VESDA探測', '潔淨氣體滅火'] },
          { title: '網絡', items: ['Equinix Fabric', '500+網絡提供商'] },
          { title: '安全', items: ['雙重門禁', '生物識別+門卡'] },
          { title: '運維', items: ['24/7智能手服務', '全球NOC支援'] }
        ]
      },
      'eq-ty8': {
        name: 'Equinix TY8 東京',
        region: '日本',
        location: '日本東京',
        subtitle: '亞太金融中心 · 超低延遲',
        advantageTitle: 'Equinix 東京優勢',
        infrastructureTitle: '企業級基礎設施',
        notices: [
          { title: '金融中心位置', desc: '直連東京證券交易所生態' },
          { title: '超低延遲', desc: '為高頻交易優化' },
          { title: '災難恢復', desc: '抗震隔離和備用電源' }
        ],
        descriptions: [
          '為金融服務和企業專門建造',
          '連接日本主要營運商和IX',
          '健全的災害預防基礎設施'
        ],
        infrastructure: [
          { title: '電力系統', items: ['2N並發可維護', '72小時燃料儲備'] },
          { title: '製冷系統', items: ['N+1 CRAC單元', '冷熱通道封閉'] },
          { title: '消防系統', items: ['VESDA + FM200'] },
          { title: '網絡', items: ['200+網絡提供商', '連接JPIX/JPNAP'] },
          { title: '安全', items: ['24/7安保人員', '多因素認證'] },
          { title: '運維', items: ['雙語支援', '現場工程支援'] }
        ]
      },
      'coresite-la1': {
        name: 'CoreSite LA1 數據中心',
        region: '美國',
        location: '洛杉磯, CA',
        subtitle: '西海岸連接樞紐，直連亞太海底光纜',
        advantageTitle: 'CoreSite LA1 戰略優勢',
        infrastructureTitle: '核心基礎設施',
        notices: [
          { title: '行業認證', desc: 'ISO 27001認證，24/7工程支援' },
          { title: '穩定供電', desc: 'N+1冗餘UPS設計確保可靠性' },
          { title: '液冷設施', desc: '冷凝製冷提升能效' }
        ],
        descriptions: [
          '位於One Wilshire - 西海岸最關鍵的網絡交換樞紐',
          '超過17.3萬平方英尺設施，配備尖端基礎設施',
          '適合高密度、計算密集型部署'
        ],
        infrastructure: [
          { title: '電力系統', items: ['N+1冗餘UPS', '備用柴油發電機(72小時)', '多元化電源'] },
          { title: '製冷系統', items: ['N+1冷却塔和冷水機', '冷凝製冷', 'RFID環境監控'] },
          { title: '消防系統', items: ['VESDA早期煙霧探測', '雙聯鎖預作用乾式噴淋'] },
          { title: '網絡架構', items: ['數百家營運商+暗光纖', 'AWS Direct Connect/Azure ExpressRoute'] },
          { title: '安全系統', items: ['生物識別+24/7安保人員'] },
          { title: '技術支援', items: ['24/7運維，100% SLA正常運行時間保證'] }
        ]
      },
      'west7': {
        name: 'West 7 洛杉磯地下設施',
        region: '美國',
        location: '洛杉磯, CA',
        subtitle: '全球最大地下數據樞紐 · 跨太平洋門戶',
        advantageTitle: '西海岸數字堡壘',
        infrastructureTitle: '核心基礎設施',
        notices: [
          { title: 'Tier III+ 地下堡壘', desc: '17.2萬平方英尺，99.995%可用性' },
          { title: '17MW電力冗餘', desc: '雙電網+3000kVA UPS+72小時備電' },
          { title: '戰略網絡樞紐', desc: '直連6條跨太平洋光纜' }
        ],
        descriptions: [
          '深層岩石位置: 抗靉9級，7米防洪',
          'TPE/EAC-C2C光纜終端: 到東京<85ms，到上海<120ms',
          'ISO 27001/SSAE 18認證，30Pa正壓容投'
        ],
        infrastructure: [
          { title: '電力系統', items: ['2N UPS(3000kVA)+18×2MVA變壓器', '雙路138kV饋電+72小時發電機'] },
          { title: '製冷系統', items: ['9,000噸水冷(PUE≤1.35)', '地熱岩層製冷(±0.5℃穩定性)'] },
          { title: '消防系統', items: ['VESDA激光探測+氟代酮滅火'] },
          { title: '網絡架構', items: ['12家一級營運商包括AT&T/Verizon', '100Gbps主幹+BGP優化'] },
          { title: '物理安全', items: ['軍用級生物識別+防尾隨氣閘', '防彈玻璃監控室+動態壓力傳感器'] },
          { title: '運維', items: ['24/7工程師，5分鐘緊急SLA', '4小時硬體故障更換'] }
        ]
      },
      'tyo1': {
        name: 'DigitalEdge TYO1 東京數據中心',
        region: '日本',
        location: '東京文京區',
        subtitle: '文京核心 · Tier III認證 · 3.76MW高密度樞紐',
        advantageTitle: '東京數字樞紐中心',
        infrastructureTitle: '核心設施規格',
        notices: [
          { title: '金融級低延遲', desc: '連接8大交易所節點，HFT延遲<0.5ms' },
          { title: '全冗餘基礎設施', desc: 'N+1 UPS+三路供電，燃氣渦輪機24小時備電' },
          { title: '東京黃金地段', desc: '距山手線5分鐘，毗鄰電信樞紐' }
        ],
        descriptions: [
          '2,470㎡託管空間，940個機櫃，三重ISO認證',
          'Cross Link™低延遲連接TYO2/TYO3',
          'FSA指定合規設施，支援HFT和邊緣計算'
        ],
        infrastructure: [
          { title: '電力系統', items: ['三路市電供應', 'N+1並聯冗餘UPS', '3×4,000kVA燃氣渦輪機(24小時儲備)'] },
          { title: '製冷系統', items: ['N+1地板下送風空調', 'PUE 1.5東京低碳合規', '每機櫃4kVA功率密度'] },
          { title: '消防系統', items: ['VESDA吸氣式探測', '惰性氣體滅火'] },
          { title: '網絡架構', items: ['3條獨立光纖入口', '支援Cross Connect & Cross Link™互聯'] },
          { title: '物理安全', items: ['生物識別+防尾隨+24/7 SOC', '超越日本建築標準的抗震設計'] },
          { title: '運維', items: ['24/365遠程手服務', '100%雙電路/99.99%單電路SLA'] }
        ]
      },
      'tgt': {
        name: 'TGT 香港數據中心',
        region: '香港',
        location: '香港將軍澳',
        subtitle: '將軍澳核心樞紐 · 戰略海底光纜節點',
        advantageTitle: '亞洲核心數字樞紐',
        infrastructureTitle: '軍工級基礎設施',
        notices: [
          { title: 'TIA-942 Rated 3+ 認證', desc: '99.982%正常運行，雙路電源+72小時備電' },
          { title: '海底光纜直連', desc: '到亞洲主要城市延遲<5ms' },
          { title: '燃氣管道光纖技術', desc: 'GIG技術減少故障60%，抗震' }
        ],
        descriptions: [
          '位於將軍澳工業邨22號 - 亞洲政府規劃的數據中心樞紐',
          '5層、2.2萬平方米設施，支援3,300個高密度機櫃',
          '先進安全基礎設施，適合跨境業務擴展'
        ],
        infrastructure: [
          { title: '電力系統', items: ['18,000KVA+2N冗餘UPS+24×2MVA變壓器', '雙路11kV供電+柴油備用(72小時)'] },
          { title: '製冷系統', items: ['水冷+溴化錢吸收式(PUE≤1.5)', '熱通道封閉±0.5℃穩定性'] },
          { title: '消防系統', items: ['VESDA + FM200潔淨氣體滅火'] },
          { title: '網絡架構', items: ['7家一級營運商包括PCCW/HKBN', '雙 POP+BGP多路徑切換'] },
          { title: '物理安全', items: ['生物識別+熱成像(ISO27001/9001)'] },
          { title: '運維', items: ['24/7工程師，15分鐘響應SLA'] }
        ]
      },
      'global-switch-woolands': {
        name: 'Global Switch Woodlands 設施',
        region: '新加坡',
        location: '新加坡兆基',
        subtitle: '亞太綠色數字樞紐 · 30MW雙活設計',
        advantageTitle: '東南亞數字樞紐',
        infrastructureTitle: '核心基礎設施',
        notices: [
          { title: 'Tier III+ 認證設施', desc: '99.982%正常運行，雙變電站+24小時備電' },
          { title: '新加坡能效標框', desc: 'PUE 1.34，LEED金級+BCA鉑金' },
          { title: '金融級安全', desc: 'MAS合規，防撞屏障+生物識別' }
        ],
        descriptions: [
          '7層兆基設施(2.5萬平方米)，7,800機櫃容量',
          '到大成設施<1ms光纖，300+營運商',
          '模塊化預製(60% MEP工廠建造)'
        ],
        infrastructure: [
          { title: '電力系統', items: ['雙變電站供電(30MVA)', '18台屋頂DRUPS(N+2)', '20萬升燃料儲存(24/7供電)'] },
          { title: '製冷系統', items: ['變頻風機+高效CRAH', '3.5米淨高支援58U機櫃', '可重配置配電'] },
          { title: '消防系統', items: ['VESDA吸氣式探測', 'FM200潔淨氣體滅火'] },
          { title: '網絡架構', items: ['雙光纖到MMR交換室', '5噸專用貨梯'] },
          { title: '物理安全', items: ['防撞屏障+周界探測', '屋頂發電機保護系統'] },
          { title: '運維', items: ['24/7工程支援', '零停機遷移服務'] }
        ]
      }
    }
  },
  
  // Legal Pages
  legal: {
    legal: '法律',
    tableOfContents: '目錄',
    lastUpdated: '最後更新',
    contactInfo: '如對這些政策有任何疑問，請通過郵件聯繫我們',
    otherPolicies: '其他政策',
    tosDesc: '我們的服務條款規定您使用我們服務的方式',
    privacyDesc: '我們的隱私權政策解釋我們如何收集、使用和保護您的個人信息',
    aupDesc: '我們的可接受使用政策概述了允許和禁止的服務使用方式',
    dsaDesc: '我們的數字服務法案政策符合歐盟法規',
    dmcaDesc: '我們的DMCA政策處理版權侵權索賠',
    
    tos: {
      section1Title: '引言',
      section1Content1: '歡迎來到Nebula Global LLC。這些服務條款管轄您對我們網站、服務和產品的使用。',
      section1Content2: '通過訪問或使用我們的服務，您同意受這些條款和所有適用法律和法規的約束。',
      section2Title: '使用許可',
      section2Content1: '根據這些條款，我們授予您有限的、非獨佔的許可證，以訪問和供個人使用我們的服務。',
      section2Content2: '此許可證不包括任何轉售或商業使用我們的服務或相關內容。',
      section3Title: '用戶帳戶',
      section3Sub1: '帳戶註冊',
      section3Item1: '您必須提供準確完整的信息',
      section3Item2: '您必須維護和更新您的帳戶信息',
      section3Item3: '您有責任保護您的帳戶憑證',
      section3Item4: '您對帳戶下發生的所有活動負責',
      section3Sub2: '帳戶終止',
      section3Item5: '我們可以隨時終止或暫停您的帳戶',
      section3Item6: '您可以隨時關閉您的帳戶',
      section3Item7: '一旦終止，您使用服務的權利將停止',
      section4Title: '禁止使用',
      section4Sub1: '非法活動',
      section4Item1: '將我們的服務用於任何非法目的',
      section4Item2: '違反任何本地、州、國家或國際法律',
      section4Item3: '從事欺詐活動',
      section4Sub2: '系統濫用',
      section4Item4: '試圖獲得對我們系統的未授權訪問',
      section4Item5: '引入病毒或惡意代碼',
      section4Item6: '用過多請求超載我們的服務器',
      section5Title: '付款和計費',
      section5Item1: '所有服務均需預付款',
      section5Item2: '我們保留隨時更改定價的權利',
      section5Sub1: '計費週期',
      section5Item3: '根據服務不同，計費按月或按年進行',
      section5Sub2: '付款方式',
      section5Item4: '我們接受信用卡、PayPal和銀行轉賬',
      section5Item5: '逾期付款可能導致服務暫停',
      section6Title: '終止',
      section6Sub1: '由您終止',
      section6Item1: '您可以隨時終止您的訂閱',
      section6Item2: '某些服務可能有取消費用',
      section6Item3: '退款受我們的退款政策約束',
      section6Sub2: '由我們終止',
      section6Item4: '我們可能因違反條款而終止您的訪問權限',
      section6Item5: '我們將在終止前提供通知',
      section7Title: '保證免責聲明',
      section7Sub1: '服務可用性',
      section7Item1: '我們的服務按原樣提供，不提供任何保證',
      section7Item2: '我們不保證服務可用性的無間斷性'
    },
    
    privacy: {
      section1Title: '我們收集的信息',
      section1Content: '我們收集您直接提供給我們的信息，例如當您創建帳戶、使用我們的服務或與我們溝通時。',
      section2Title: '我們如何使用信息',
      section2Item1: '提供、維護和改進我們的服務',
      section2Item2: '處理交易並發送相關通信',
      section2Item3: '發送技術通知和支持消息',
      section2Item4: '防範欺詐和濫用',
      section3Title: '信息共享',
      section3Item1: '經您的同意',
      section3Item2: '與需要訪問權限的供應商和服務提供商',
      section3Item3: '按法律或法律程序要求',
      section4Title: '數據安全',
      section4Content: '我們實施適當的技術和組織措施，以保護個人數據免遭未經授權的訪問、更改、披露或銷毀。',
      section5Title: '您的權利',
      section5Content: '根據您的位置，您可能有權訪問、更正或刪除您的個人信息。請聯繫我們行使這些權利。',
      section6Title: '聯繫我們',
      section6Content: '如果您對此隱私政策有任何疑問，請通過郵件聯繫我們。'
    },
    
    aup: {
      section1Title: '可接受使用',
      section1Content: '我們的服務只能用於合法目的，並遵守這些條款。您同意不將我們的服務用於發送垃圾郵件、分發惡意軟件或從事任何有害活動。',
      section2Title: '禁止活動',
      section2Item1: '發送未經請求的批量電子郵件或垃圾郵件',
      section2Item2: '託管非法內容或從事非法活動',
      section2Item3: '分發惡意軟件、病毒或其他有害軟件',
      section2Item4: '試圖侵犯安全或獲得未授權訪問',
      section2Item5: '超載系統或中斷服務',
      section3Title: '執行',
      section3Content: '違反此AUP可能導致您的帳戶被暫停或終止。我們保留調查投訴並採取適當行動的權利。',
      section4Title: '報告違規行為',
      section4Content: '如果您意識到我們服務的任何濫用情況，請通過郵件報告。'
    },
    
    dsa: {
      section1Title: '應用範圍',
      section1Content: '本政策適用於我們作為《數字服務法案》所定義的在線中介服務。我們致力於確保我們的服務符合歐盟法規。',
      section2Title: '通知和行動',
      section2Content: '我們已建立接收和處理非法內容或知識產權侵權通知的程序。',
      section3Title: '透明度報告',
      section3Content: '我們發布年度透明度報告，詳細說明我們在DSA下的合規努力和執法行動。'
    },
    
    dmca: {
      section1Title: '版權政策',
      section1Content: '我們尊重他人的知識產權，並期望我們的服務用戶也這樣做。',
      section2Title: '版權侵權通知',
      section2Item1: '必須以書面形式並由版權所有者或授權代理人簽名',
      section2Item2: '必須確定聲稱被侵犯的版權作品',
      section2Item3: '必須確定聲稱侵權的材料',
      section2Item4: '必須包括投訴方的聯繫信息',
      section2Item5: '必須包括誠信信念和準確性的聲明',
      section3Title: '反通知',
      section3Content: '那些被移除內容的人可以提交挑戰移除的反通知。',
      section4Title: '重複侵權者',
      section4Content: '在適當情況下，我們將終止重複侵權者的帳戶。'
    }
  },
  contact: {
    contactUs: '聯繫我們',
    contactDesc: '我們很樂意聽取您的意見。<br>如有諮詢、反饋或合作意向，請聯繫我們。',
    openTicket: '提交工單',
    phoneSupport: '電話支援',
    phoneDesc: 'VIP解決方案，24/7全天候服務',
    callNow: '立即撥打',
    supportTicket: '支援工單',
    email: '電子郵件',
    preSalesAfterSales: '售前與售後',
    channelTitle: '常見問題解答，幫助您快速入門',
    liveChat: '線上客服',
    liveChatDesc: '即時聊天，即時解答',
    hours: '服務時間',
    phoneSupportDesc: '快速響應，24/7全天候服務',
    ticketDesc: '提交工單，我們將盡快回覆',
    priority: '優先',
    documentation: '文檔中心',
    docDesc: '查看常見問題和教程',
    selfService: '自助服務',
    ourOffices: '我們的辦事處',
    officeWelcome: '歡迎來訪，我們竭誠為您服務',
    usHeadquarters: '美國總部',
    hongKongOffice: '香港',
    announcements: '公告',
    networkStatus: '網絡狀態',
    myTickets: '我的工單'
  },
  
  // Pages
  pages: {
    activity: {
      title: '最新活動',
      subtitle: '查看當前的優惠活動',
      metaDesc: '最新優惠活動，新用戶專享福利'
    },
    products: {
      title: '產品與服務',
      subtitle: '查看我們的全部產品',
      metaDesc: '提供雲伺服器、物理伺服器、SSL證書、網域註冊等產品'
    },
    solutions: {
      title: '解決方案',
      subtitle: '專業的企業級解決方案',
      metaDesc: '提供混合雲、跨雲互聯、頻寬服務等企業級解決方案'
    },
    docs: {
      title: '文檔中心',
      subtitle: '產品文檔和使用教程',
      metaDesc: '產品文檔、API文檔和使用教程'
    },
    news: {
      title: '新聞公告',
      subtitle: '最新的新聞和公告資訊',
      metaDesc: '最新新聞、公告和行業動態'
    },
    cloud: {
      title: '雲伺服器',
      subtitle: '彈性伸縮的雲計算解決方案',
      metaDesc: '雲伺服器，彈性伸縮，按需付費，快速部署'
    },
    server: {
      title: '物理伺服器',
      subtitle: '高性能獨立伺服器解決方案',
      metaDesc: '高性能物理伺服器，專屬資源保障'
    },
    ssl: {
      title: 'SSL證書',
      subtitle: '保護您的網站安全',
      metaDesc: 'SSL證書，快速簽發，保護網站安全'
    },
    domain: {
      title: '網域註冊',
      subtitle: '快速註冊您的網域',
      metaDesc: '網域註冊，多種後綴選擇，價格優惠'
    }
  }
}
